import React from "react";
import SEOKeyword from "../../share/components/seo-keyword.component";
import { useTranslation } from "react-i18next";

const OrganicKeywords = () => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <SEOKeyword
        type={"organic"}
        title={t("site_audit.dashboard_page.box.organic_keyword.title")}
      />
    </React.Fragment>
  );
};

export default OrganicKeywords;
